import MetadataParse from "./MetadataParse";

export default {
  async mountMetadataFilter(_, metadata) {
    const selectedMetadataFilter = await MetadataParse.getSelectedFromMetadata(metadata);
    const selectedMetadataGrouped = MetadataParse.createGroupFilters(selectedMetadataFilter);
    return { metadataFilters: selectedMetadataFilter, metadataFiltersGrouped: selectedMetadataGrouped };
  },
  getMetadataGroup(_, metadataFiltersGrouped) {
    const filters = metadataFiltersGrouped.filter((current) => current.length);
    return MetadataParse.getMetadataFromFilter(filters);
  },
  addMetadataFilter(_, { metadataFilters, newFilter }) {
    const newMetadataFilters = metadataFilters.concat(newFilter);
    const metadataFiltersGrouped = MetadataParse.createGroupFilters(newMetadataFilters);
    return { metadataFilters: newMetadataFilters, metadataFiltersGrouped: metadataFiltersGrouped };
  },
  removeMetadataFilter(_, { metadataFilters, removedFilterKey }) {
    const newMetadataFilters = metadataFilters.filter((filter) => filter.key !== removedFilterKey);
    const metadataFiltersGrouped = MetadataParse.createGroupFilters(newMetadataFilters);
    return { metadataFilters: newMetadataFilters, metadataFiltersGrouped: metadataFiltersGrouped };
  },
  changeComparator(_, { metadataFilters, key, comparator }) {
    const newMetadataFilters = metadataFilters.map((f) => {
      if (f.key === key) {
        f.comparator = comparator;
      }
      return f;
    });
    const metadataFiltersGrouped = MetadataParse.createGroupFilters(newMetadataFilters);
    return { metadataFilters: newMetadataFilters, metadataFiltersGrouped: metadataFiltersGrouped };
  }
};
